import React, { useEffect, useState } from "react";
import { CustomListComponent } from "../../../components/custom-list-component/CustomListComponent";
import { useSelector } from "react-redux";
import { getUserDevices } from "../../../api";
import { useIntl } from "react-intl";
import CustomDataGrid from "../../../components/custom-data-grid/CustomDataGrid";

export const DeviceList = () => {
  const intl = useIntl();

  const storedIdCrm = useSelector((state) => state.idCrm);
  const storedIdUser = useSelector((state) => state.idUser);

  const [devices, setDevices] = useState(null);

  const getDevicesCallback = (data) => {
    setDevices(data);
  };

  const handleSubmit = () => {
    getUserDevices(storedIdCrm, storedIdUser, getDevicesCallback);
  };

  useEffect(() => {
    if (!!storedIdCrm && !!storedIdUser) {
      handleSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      field: "idDispositivo",
      headerName: intl.formatMessage({ id: "custom.devices.id" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "idCrm",
      headerName: intl.formatMessage({ id: "custom.id_crm" }),
      flex: 1,
      sortable: false,
      valueGetter: () => {
        return storedIdCrm || " - ";
      },
    },
    {
      field: "fechaAlta",
      headerName: intl.formatMessage({ id: "custom.devices.registration_date" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "disInfo",
      headerName: intl.formatMessage({ id: "custom.devices.info" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "dispAlias",
      headerName: intl.formatMessage({ id: "custom.devices.alias" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "pinActivado",
      headerName: intl.formatMessage({ id: "custom.devices.activated_pin" }),
      flex: 1,
      sortable: false,
      valueGetter: (params) => {
        return params.row?.pinActivado || " - ";
      },
    },
  ];

  return (
    <>
      <CustomListComponent
        title={intl.formatMessage({ id: "menu.device_list" })}
        handleSubmit={handleSubmit}
        setter={setDevices}
      />
      {devices && (
        <div>
          <CustomDataGrid columns={columns} rows={devices} getRowId={(row) => row.idDispositivo} />
        </div>
      )}
    </>
  );
};
